/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { useNavigate } from "react-router-dom";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { useEffect, useState } from "react";
import { fevirPublicationStatusActive, fevirPublicationStatusDraft } from "../dictionaries/THOandFHIRValueSets";
import { Button, Segment } from "semantic-ui-react";
import ProfilesByResourceType from "../dictionaries/ProfilesByResourceType";
import StringEntry from "../datatypeComponents/StringEntry";
import submitResource from "./resourceDisplayCommonFunctions/submitResource";

const NewTitleEntry = ({ newResourceState, setNewResourceState }) => {

    let itemTypeDisplay = newResourceState.resourceType + " Resource";
    if (newResourceState.meta?.profile) {
        for (const profile of newResourceState.meta.profile) {
            const profileDictionary = ProfilesByResourceType[newResourceState.resourceType];
            for (const key in profileDictionary) {
                if (profileDictionary[key].url === profile) {
                    itemTypeDisplay = key;
                    break;
                }
            }
        }
    }
    return <div>
        <div style={{ marginLeft: "24px" }}>
            <p>Enter a title here and click Submit to create a new blank {itemTypeDisplay}.</p>
            <StringEntry elementName='title' fieldLabel='Title'
                startingValue={newResourceState.title} setResourceState={setNewResourceState} />
        </div>
    </div>
}

const ProfileSpecificCreateResourcePage = ({ resourceStarter }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const apiToken = useSelector(selectCurrentUserApiToken);

    const [fhirEntryState, setFhirEntryState] = useState({ "fhirEntry": "", "status": "active" });

    const [newResourceState, setNewResourceState] = useState(resourceStarter);

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Resource Entry"));
    }, []);

    useEffect(() => {
        if (fhirEntryState.status && fhirEntryState.fhirEntry) {
            let newPublicationStatus = fevirPublicationStatusActive;
            if (fhirEntryState.status === "draft") {
                newPublicationStatus = fevirPublicationStatusDraft;
            }
            let newFhirJson = JSON.parse(fhirEntryState.fhirEntry);
            if (newFhirJson.extension) {
                let publicationExtensionFound = false;
                for (let extension of newFhirJson.extension) {
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-publication-status") {
                        extension.valueCodeableConcept = newPublicationStatus;
                        publicationExtensionFound = true;
                    }
                }
                if (!publicationExtensionFound) {
                    newFhirJson.extension.push({
                        "url": "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-publication-status",
                        "valueCodeableConcept": newPublicationStatus
                    });
                }
            } else {
                newFhirJson.extension = [{
                    "url": "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-publication-status",
                    "valueCodeableConcept": newPublicationStatus
                }]
            }
            let newFhirEntry = JSON.stringify(newFhirJson);
            setFhirEntryState(prevState => { return { ...prevState, "fhirEntry": newFhirEntry }; });
        }
    }, [fhirEntryState.status]);

    useEffect(() => {
        if (JSON.stringify(newResourceState) !== JSON.stringify({ "resourceType": "", "title": "" })) {
            let newJson = {
                "resourceType": newResourceState.resourceType,
                "meta": newResourceState.meta,
                "title": newResourceState.title
            };
            if (newResourceState.resourceType === "CodeSystem") {
                newJson.concept = [];
            }
            if (newResourceState.section) {
                newJson.section = newResourceState.section;
            } else if (newResourceState.resourceType === "Composition") {
                newJson.section = [];
            }
            setFhirEntryState(prevState => {
                return {
                    ...prevState,
                    "fhirEntry": JSON.stringify(newJson)
                };
            });
        }
    }, [newResourceState]);

    if (!resourceStarter) {
        return <div>
            <p>THERE IS AN ERROR. YOU HAVE REACHED THE ProfileSpecificCreateResourcePage WITHOUT A resourceStarter VALUE. EMAIL support@computablepublishing.com</p>
        </div>
    }

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            <br /><br />
            {apiToken ?
                <>
                    <NewTitleEntry newResourceState={newResourceState} setNewResourceState={setNewResourceState} />
                    <br />
                    <Button className="formButton positive" content="Submit" compact
                        onClick={() => {
                            submitResource(fhirEntryState.fhirEntry, apiToken,
                                navigate, dispatch, fhirEntryState.status);
                        }}
                        disabled={!newResourceState.title && !newResourceState.name} />
                </>
                :
                <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
            }
        </Segment>
    </div>
}

export default ProfileSpecificCreateResourcePage;